import {applyMiddleware, compose, createStore, Store} from 'redux';
import createSagaMiddleware, {SagaMiddleware} from 'redux-saga';

import rootReducer from './reducers';
import rootSaga from './sagas';

import webSocketMiddleware from '#app/api/middleware/webSocketMiddleware';

// @TODO уточнить типы
const configureStore = (initialState: any = {}): Store<any> => {
    const sagaMiddleware: SagaMiddleware = createSagaMiddleware();

    const composedEnhancers = compose(applyMiddleware(
        sagaMiddleware,
        webSocketMiddleware
    ));

    const store = createStore(rootReducer(), initialState, composedEnhancers);

    sagaMiddleware.run(rootSaga);

    // if (process.env.NODE_ENV !== 'production') {
    //   if (module.hot) {
    //     module.hot.accept('./reducers', () => {
    //       store.replaceReducer(rootReducer)
    //     })
    //   }
    // }

    return store;
};

export default configureStore;










